/** MANUAL plan marker bbox from centi-percent position (matches core-service `UpdateDoorMarkerPositionDTO`). */
export function markerPositionToBbox(leftPct: number, topPct: number): {
  bboxX1: number;
  bboxY1: number;
  bboxX2: number;
  bboxY2: number;
} {
  const bboxX1 = Math.round(leftPct * 100);
  const bboxY1 = Math.round(topPct * 100);
  return {
    bboxX1,
    bboxY1,
    bboxX2: bboxX1 + 1,
    bboxY2: bboxY1 + 1,
  };
}

export function isPointCentiBbox(bbox: {
  bboxX1: number;
  bboxY1: number;
  bboxX2: number;
  bboxY2: number;
}): boolean {
  return bbox.bboxX2 - bbox.bboxX1 <= 1 && bbox.bboxY2 - bbox.bboxY1 <= 1;
}

export function centerPctFromCentiBbox(bbox: {
  bboxX1: number;
  bboxY1: number;
  bboxX2: number;
  bboxY2: number;
}) {
  return {
    leftPct: (bbox.bboxX1 + bbox.bboxX2) / 2 / 100,
    topPct: (bbox.bboxY1 + bbox.bboxY2) / 2 / 100,
  };
}
